
import { Component, Inject, Vue } from 'vue-property-decorator';
import UserDisplay from '@/ui/UserDisplay.vue';
import GlobalState from '@/util/GlobalState';
import { Subscription } from 'rxjs';
import { BeforeDestroyAware, CreatedAware } from '@/util/lifecycle';
import Message from '@/util/Message';
import MessageBar from '@/ui/MessageBar.vue';

@Component({
    components: {
        MessageBar,
        UserDisplay,
    },
})
export default class Scaffold extends Vue implements CreatedAware, BeforeDestroyAware {
    public message: Message | null = null;
    public showMessage = false;

    @Inject()
    private readonly globalState!: GlobalState;
    private eventSubscription = new Subscription();

    public created(): void {
        this.eventSubscription = this.globalState.messageBus.subscribe((message) => {
            this.message = message;
            this.showMessage = true;
        });
    }

    public beforeDestroy(): void {
        this.eventSubscription.unsubscribe();
    }

    public onLogoClicked(): void {
        //
    }
}
